module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="shared-notification-toast shared-toast toast-success" role="alert">\n  <span class="shared-notifications-message-text">\n    Cookie settings saved! Please refresh the page.\n  </span>\n  <i class="rm rm-times-r shared-notifications-dismiss-notification-button" aria-hidden="true" aria-label="Close notification" />\n</div>\n';

}
return __p
}